import { createSvgComponent } from "../../icon/createSvgComponent";
import FourLeafClover from "@core/icon/assets/four-leaf-clover.svg";
export default createSvgComponent(FourLeafClover);